const CURRENT_USER = "currentUser";
const TOKEN_NAME = "token";

export default {
  CURRENT_USER,
  TOKEN_NAME,
};
